var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { EntityTypeConfigurationHelper } from "../../../../../models/basics/basics.models";
import { SourceType, QueryFilter, DataType } from "../../../../../models/queries/queries.models";
import { QueriesClientService } from "../../../../../services/queries/queries-client.services";
import * as Enumerable from "linq";
import { UserModel } from "../../../../../models/modules/lotteryplatofrm.models";
import { QueriesEditor } from "../../../../components/queries/queries-editor";
import { TokenClient } from "../../../../../services/authentication/token-client.service";
var OperatorTransactions = /** @class */ (function (_super) {
    __extends(OperatorTransactions, _super);
    function OperatorTransactions(notificationService, i18N, entityTypeConfigurationHelper, tokenClient, queriesService) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.entityTypeConfigurationHelper = entityTypeConfigurationHelper;
        _this.tokenClient = tokenClient;
        _this.queriesService = queriesService;
        return _this;
    }
    OperatorTransactions.prototype.onActivated = function (item) {
        var _this = this;
        var filters = [QueryFilter.getQuery("operatorId", item.operatorId, "eq", DataType.Number)];
        var path = "Transactions";
        var uri = "odata/".concat(path);
        this.queriesService.getEntityModels().then(function (models) {
            var e_1, _a;
            var columns = [];
            var selectedModel = Enumerable.from(models).firstOrDefault(function (y) { return y.uri == path; });
            try {
                for (var _b = __values(selectedModel.projectionProperties), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item_1 = _c.value;
                    var column = QueriesEditor.generateDefaultColumn(item_1, selectedModel);
                    UserModel.enableAgentColumnNameReplacement(_this.tokenClient.user, column);
                    columns.push(column);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            _this.itemSource = {
                source: uri,
                sourceType: SourceType.ODataUrl,
                columns: columns,
                initialFilters: filters,
                groupInitialFilters: true
            };
        }, function (error) {
            _this.notificationService.show(_this.i18N.tr('error-text') + "!", _this.i18N.tr('error-loading-meta-data-for-query-editor-text'), NotificationType.Error);
        });
    };
    OperatorTransactions = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N,
            EntityTypeConfigurationHelper,
            TokenClient,
            QueriesClientService])
    ], OperatorTransactions);
    return OperatorTransactions;
}(ChildComponent));
export { OperatorTransactions };
